module.exports = __webpack_public_path__ + "856a956dbb408fffefe8b462f15f312d.jpg";